<template lang="pug">
AppDialog.shift-overlap-confirmation-dialog(
  size="medium"
  position="centered"
  append-to-body
  has-footer
  title="Shift overlap"
  :show="show"
  @close="close()"
)
  .warning
    i.hi-important.icon
    p {{ timeOffRequest.shiftOverlapMessage }}

  .question
    p {{ timeOffRequest.shiftOverlapQuestion }}

  template(#footer)
    .actions
      AppButton(
        type="danger"
        @click="approveTimeOffRequest({ removeShifts: true })"
      ) Remove {{ $filters.pluralize(timeOffRequest.shiftCount, 'Shift') }}

      AppButton(
        type="primary"
        @click="approveTimeOffRequest({ removeShifts: false })"
      ) Keep {{ $filters.pluralize(timeOffRequest.shiftCount, 'Shift') }}
</template>

<script>
import { applyTemplate } from '~/utils/url_template';
import { TIME_OFF_REQUEST_URL } from '~/app_constants';

export default {
  name: 'ShiftOverlapConfirmationDialog',
  props: {
    show: {
      type: Boolean,
      default: true,
    },
    timeOffRequest: {
      type: Object,
      required: true,
    },
  },
  computed: {
    shiftButtonText() {
      return this.timeOffRequest.shiftCount > 1 ? 'Shifts' : 'Shift';
    },
  },
  methods: {
    approveTimeOffRequest({ removeShifts }) {
      const url = applyTemplate(`${TIME_OFF_REQUEST_URL}/update_status`, {
        id: this.timeOffRequest.id,
      });
      const approvedStatusId = this.timeOffRequest.statuses.find((status) => status.name === 'Approved').id;
      const data = {
        time_off_request: {
          status: approvedStatusId,
          response: 'Approved through the schedules calendar',
          remove_shifts: removeShifts ? '1' : '0',
        },
      };

      this.$inertia.post(url, data, {
        onSuccess: () => {
          this.close();
        },
      });
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>
